/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupwaitlist1Inputs */

const en_signupwaitlist1 = /** @type {(inputs: Signupwaitlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting list once all seats are taken`)
};

const de_signupwaitlist1 = /** @type {(inputs: Signupwaitlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warteliste, wenn alle Plätze vergeben sind`)
};

/**
* | output |
* | --- |
* | "Waiting list once all seats are taken" |
*
* @param {Signupwaitlist1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupwaitlist1 = /** @type {((inputs?: Signupwaitlist1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupwaitlist1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupwaitlist1(inputs)
	return de_signupwaitlist1(inputs)
});
export { signupwaitlist1 as "signupWaitlist" }